<template>
  <div class="w-full pb-0 laptop:pb-10 pt-10">
    <div
      class="gridClass flex justify-between flex-col-reverse laptop:flex-row"
    >
      <div
        class="pb-0 flex flex-col laptop:pe-10"
        :class="hasSpace ? 'justify-between' : 'justify-start'"
      >
        <div class="mt-6">
          <slot name="title"></slot>

          <div v-if="!slots.title && details.title">
            <h1
              class="font-extrabold just-desktop text-2xl mb-5 text-start"
              :class="isDark ? 'text-white' : 'text-blue-500'"
            >
              {{ details.title }}<span v-if="details.subtitle">؛</span>
              {{ details.subtitle }}
            </h1>
            <div
              class="font-extrabold just-mobile mb-5 text-center"
              :class="isDark ? 'text-white' : 'text-blue-500'"
            >
              <div class="text-xl mb-1">{{ details.title }}</div>
              <div class="text-base">{{ details.subtitle }}</div>
            </div>
          </div>

          <slot name="description"></slot>
          <div
            v-if="!slots.description"
            class="font-semibold laptop:font-bold text-justify text-base leading-7"
            v-html="details.desc"
            :class="isDark ? 'text-white' : ''"
          />
        </div>
        <slot name="button"></slot>
        <div
          v-if="details.firstButton || details.secondButton"
          class="flex mt-10 laptop:mb-1 flex-col laptop:flex-row [&>*]:mb-4 [&>*]:laptop:mb-0 [&>*]:laptop:w-[45%] justify-between"
        >
          <div v-if="details.firstButton">
            <ProductButton :buttonInfo="details.firstButton" />
          </div>
          <div v-if="details.secondButton">
            <ProductButton :buttonInfo="details.secondButton" />
          </div>
        </div>
      </div>
      <div class="min-w-[50%]">
        <NuxtImg
          v-if="details.img"
          sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
          width="1000"
          height="1000"
          quality="100"
          format="webp"
          class="w-full laptop:!w-[80%] mx-auto rounded-xl"
          :class="details.imgClass"
          :src="details.img"
          :alt="details.title"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useSlots } from "vue";

defineProps({
  details: Object,
  hasSpace: Boolean,
  isDark: Boolean,
});

const slots = useSlots();

const scrollTo = (id) => {
  const position = findPosition(document.getElementById(id));
  window.scroll(0, position[0] - 100);
};

const findPosition = (obj) => {
  var currenttop = 0;
  if (obj.offsetParent) {
    do {
      currenttop += obj.offsetTop;
    } while ((obj = obj.offsetParent));
    return [currenttop];
  }
};

const isMainModalShowState = useState("isMainModalShow");

const showMainModal = () => {
  isMainModalShowState.value = true;
};
</script>
